import { Provider } from '@angular/core';

import { LicensePlatesRepositoryImpl } from '@app/data/repositories/ptrab/license-plates/license-plates.repository';
import { LICENSE_PLATES_REPOSITORY } from '@app/domain/repositories/ptrab/license-plates/license-plates.repository.contract';

export const licensePlatesRepositoryProvider: Provider = {
  provide: LICENSE_PLATES_REPOSITORY,
  useClass: LicensePlatesRepositoryImpl
};
